import createLogger from '@/plugins/logger'

const localStoragePlugin = store => {
  store.subscribe((mutation, { todos }) => {
  })
}

export default process.env.NODE_ENV !== 'production'
  ? [createLogger(), localStoragePlugin]
  : [localStoragePlugin]
